var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.755,
    height: 15.556,
    viewBox: "0 0 15.755 15.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13854",
    "data-name": "Group 13854",
    transform: "translate(189.53 3.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13097",
    "data-name": "Group 13097",
    transform: "translate(-186.956 -2.816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5217",
    "data-name": "Rectangle 5217",
    width: 9.536,
    height: 4.14,
    transform: "translate(1.527 8.224) rotate(-45)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11159",
    "data-name": "Path 11159",
    d: "M-173.253,53.809l-.727.727a.712.712,0,0,0-.176.308l-.595,2.665a.626.626,0,0,0,.749.749l2.643-.639a.629.629,0,0,0,.308-.176l.727-.727Z",
    transform: "translate(174.77 -45.574)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11160",
    "data-name": "Path 11160",
    d: "M-113.674-.586l-2.048-2.048a.625.625,0,0,0-.881,0l-1.3,1.3,2.929,2.929,1.3-1.3A.625.625,0,0,0-113.674-.586Z",
    transform: "translate(126.173 2.816)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11161",
    "data-name": "Path 11161",
    d: "M-176.624,16.064v7.842H-189.03V11.5h7.842",
    transform: "translate(0 -12.234)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.a8312ab5d7fff521745ab813419c0c07.svg";
export { ForwardRef as ReactComponent };